import React from "react";
import "../styles/Resume.css";

function Resume() {
  return (
    <div className="resume-container">
      <div className="resume-header">
        <h1>Biel Casals Comas</h1>
        <h2>Software/ML Engineer</h2>
        <div className="contact-info">
          <span><i className="fas fa-map-marker-alt"></i> Berlin/Barcelona</span>
          <span><i className="fas fa-phone"></i> +34 698547254</span>
          <span><i className="fas fa-envelope"></i> <a href="mailto:biel.casals@gmail.com">biel.casals@gmail.com</a></span>
          <span><i className="fas fa-globe"></i> <a href="http://bcasals.com" target="_blank" rel="noopener noreferrer">bcasals.com</a></span>
        </div>
      </div>

      <section className="resume-section">
        <h3>Work Experience</h3>
        <div className="experience-item">
          <div className="experience-header">
            <h4>Software/MLOps Engineer</h4>
            <span className="company">Zalando</span>
            <span className="date">February 2022 - Present</span>
          </div>
          <ul>
            <li>
              Developed and operated ML forecasting pipelines using transformers and boosted trees.
            </li>
            <li>
              Expanded the price optimization engine, increasing market volume by 15%.
            </li>
            <li>
              Conducted model roll-outs, A/B tests, architectural decisions and on-call operations.
            </li>
            <li>
              Built automated testing, monitoring, and anomaly detection solutions.
            </li>
          </ul>
        </div>
        <div className="experience-item">
          <div className="experience-header">
            <h4>Data Science Intern</h4>
            <span className="company">Opticks Security</span>
            <span className="date">January 2021 - July 2021</span>
          </div>
          <ul>
            <li>
              Developed ML models for ad fraud detection in a start-up environment.
            </li>
          </ul>
        </div>
        <div className="experience-item">
          <div className="experience-header">
            <h4>Data Science Intern</h4>
            <span className="company">IRTA - Institute of Agrifood Research and Technology</span>
            <span className="date">July 2020 - December 2020</span>
          </div>
          <ul>
            <li>
              Developed computer vision models for fruit quality assurance.
            </li>
          </ul>
        </div>
      </section>

      <section className="resume-section">
        <h3>Education</h3>
        <div className="education-item">
          <h4>Bachelor's degree in Data Science</h4>
          <span className="institution">Universitat Pompeu Fabra</span>
          <span className="date">2017 - 2021</span>
          <p>Achieved an average of 8.5/10 with honors in Data Structures & Algorithms and Discrete Mathematics.</p>
        </div>
        <div className="education-item">
          <h4>Exchange Program</h4>
          <span className="institution">Korea University</span>
          <span className="date">August 2019 - December 2019</span>
          <p>Completed courses in Deep Learning, Business and Neuroscience.</p>
        </div>
      </section>

      <section className="resume-section">
        <h3>Skills</h3>
        <div className="skills-container">
          <div className="skill-category">
            <h4>Technical Skills</h4>
            <p>Python, Spark, AWS (SageMaker, EC2, Lambda), Airflow, Transformers, Training & Inference Optimization, CUDA, REST APIs, SRE, GCP, Kubernetes, Docker, CI/CD, CloudFormation, A/B Testing, Anomaly Detection, Monitoring, SQL, Java, C++.</p>
          </div>
          <div className="skill-category">
            <h4>Soft Skills</h4>
            <p>Agile Project Management, Prioritization, Stakeholder Alignment, Growth Feedback, Cross-Functional Collaboration, Communication</p>
          </div>
        </div>
      </section>

      <section className="resume-section">
        <h3>Languages</h3>
        <p>Catalan (native), Spanish (native), English (C1), German (B1)</p>
      </section>

      <section className="resume-section">
        <h3>Courses</h3>
        <p>The Complete SQL Bootcamp (Udemy), Machine Learning with SageMaker on AWS (edX)</p>
      </section>

      <div className="resume-download">
        <a
          href="/download-resume"
          className="download-button"
        >
          Download Full Resume (PDF)
        </a>
      </div>
    </div>
  );
}

export default Resume;
